<template>
  <el-input ref="inputRef" v-bind="$attrs" v-on="$listeners" :value="value" @input.native="set" />
</template>

<script>
export default {
  props: {
    value: {},
    isInt: { type: Boolean, default: false },
    max: { type: Number, default: 0 },
    maxLen: {}
  },

  methods: {
    set(target) {
      const v = target.target.value;
      if (this.maxLen) {
        const val = String(v).slice(0, this.maxLen);
        target.target.value = val;
        this.$emit('input', val);
        return;
      }
      if (this.max && Number(v) && Number(v) > this.max) {
        target.target.value = this.max;
        this.$emit('input', this.max);
        return;
      }
      if (parseInt(v) && this.isInt) {
        target.target.value = parseInt(v);
        this.$emit('input', parseInt(v));
        return;
      }
      this.$emit('input', v);
    },
    numberChange(val, maxNum) {
      //转换数字类型
      this.queryParams.startScore = Number(val);
      //重新渲染
      this.$nextTick(() => {
        //比较输入的值和最大值，返回小的
        let num = Math.min(Number(val), maxNum);
        //输入负值的情况下， = 0（可根据实际需求更该）
        if (num < 0) {
          this.queryParams.startScore = 0;
        } else {
          //反之
          this.queryParams.startScore = num;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/my/input.vue